export default __webpack_public_path__ + "static/media/Img_pro3.8ad0894c.jpg";